import { addField, addGroup } from 'live/widgets/helpers'
import DataService from 'live/services/charts/data'
import SpanService from 'live/services/span'
import { LollipopBuffer, LollipopEvent, LollipopState, Point } from './types'
import { eventGroupByName, mergeEvents, crop } from '../../utils'
import _ from 'lodash'

export function startQuery(actions: StartFlowMessage, state: LollipopState): LollipopState {
    if (!actions?.events) {
        return state
    }

    const { select, group } = actions.events

    const newState = {
        span: { begin: 0, end: Number.MAX_SAFE_INTEGER },
        realtime: SpanService.isRealtime(actions.events.info?.span?.text),
        fields: [],
        groups: []
    }

    select?.forEach(function (field) {
        addField(newState.fields, field)
    })
    group?.forEach(function (field) {
        addGroup(newState.groups, field)
    })

    return {
        ...state,
        ...newState
    }
}

export function getInitialState(): LollipopState {
    return {
        historyEnded: false,
        series: [],
        bufferEvents: [],
        fields: [],
        groups: []
    }
}

export function accEvents(action: EventFlowMessage<LiveEvent<LollipopEvent>>, state: LollipopState): LollipopState {
    let allEvents = []
    state.fields.forEach(field => {
        action.events.forEach(event => {
            const value = event[field]
            if (typeof value !== 'number') return

            let name = DataService.makeGroupValue(state.groups, event, ', ')
            if (!name) name = field

            const date = event.timestamp
            const axis = [date, value] as Point
            const object: LollipopBuffer = {
                name,
                data: [axis],
                marker: {
                    symbol: event?.__markerSymbol
                }
            }
            if (event?.__color != null) {
                object.color = event.__color
            }
            if (event?.__markerSymbol != null) {
                object.marker = {
                    symbol: event.__markerSymbol
                }
            }
            if (event?.__markerRadius != null) {
                if (object.marker) {
                    object.marker.radius = event.__markerRadius
                } else {
                    object.marker = {
                        radius: event.__markerRadius
                    }
                }
            }
            allEvents.push(object)
        })
    })
    allEvents.forEach(e => state.bufferEvents.push(e))

    const series = mergeEvents(state.series, allEvents)

    allEvents = []
    const newState = { ...state, series }

    return _.cloneDeep(newState)
}

export function getEndState(state: LollipopState): LollipopState {
    const groups = eventGroupByName(state.bufferEvents)

    const { begin, end } = state.span

    const series = groups.flatMap(item => {
        const filteredData = item.data.filter(data => {
            const [timestamp] = data

            return timestamp >= begin && timestamp <= end
        })

        return { ...item, data: filteredData }
    })

    return {
        ...state,
        historyEnded: true,
        series: series,
        bufferEvents: []
    }
}

export function reflectSpan(action: SpanFlowMessage, state: LollipopState): LollipopState {
    const begin = action.events.begin
    const end = action.events.end

    const series = state.series.map(element => {
        const filtered = crop(element.data, begin, end)

        if (element.data.length === filtered.length) {
            return element
        } else {
            return { ...element, data: filtered }
        }
    })

    const span = { begin, end }
    const newState = { ...state, span, series }

    return _.cloneDeep(newState)
}
